import KPI from "../models/KPI"
import LossConfiguration from "../models/LossConfiguration"
import LossStructure from "../models/LossStructure"
import Mapping from "../models/Mapping"

var ChartList = [
  new Mapping({variable: "Eficiência", valueTarget: 80, mapping:"cr|_EficienciaIndustrial|Atributos|W", type: "O", operation: 'papcht' }),
  new Mapping({variable: "Perda", valueTarget: 20, mapping:"cr|_Perdas|Atributos|W", type: "O", operation: 'papcht' }),
]

var LossList = [
  new Mapping({variable: "Bagaço", mapping:"cr|_PerdaBagaco|Atributos|W", type: "O", operation: 'paplos' }),
  new Mapping({variable: "Torta", mapping:"cr|_PerdaTorta|Atributos|W", type: "O", operation: 'paplos' }),
  new Mapping({variable: "Fermentação", mapping:"cr|_PerdaFermentacao|Atributos|W", type: "O", operation: 'paplos' }),
  new Mapping({variable: "Destilaria", mapping:"cr|_PerdaDestilaria|Atributos|W", type: "O", operation: 'paplos' }),
  new Mapping({variable: "Residuais e Lav.", mapping:"cr|_PerdaLavagemesterias|Atributos|W", type: "O", operation: 'paplos' }),
  new Mapping({variable: "Multijato", mapping:"cr|_PerdaMultijato|Atributos|W", type: "O", operation: 'paplos' }),
  new Mapping({variable: "Indeterminadas", mapping:"cr|_PerdaIndeterminada|Atributos|W", type: "O", operation: 'paplos' }),
  new Mapping({variable: "Total das Perdas", mapping:"cr|_Perdas|Atributos|W", type: "O", operation: 'paplos' }),
  new Mapping({variable: "Eficiência RTC (%)", mapping:"cr|_Eficiencia_RTC|Atributos|W", type: "O", operation: 'paplos' }),
]

var IndicatorList = [
  new Mapping({variable: "MIX Açúcar(%)", mapping:"cr|_mix|Atributos|W", type: "O", operation: 'papind' }),
  new Mapping({variable: "Potência Gerada(kW.h/t bag)", mapping:"cr|_prod_energia|Atributos|W / cr|bag_1|Atributos|W", type: "O", operation: 'papind' }),
  new Mapping({variable: "Export. Esp. Energia (kW.h/tc)", mapping:"cr|_exportacao_energia|Atributos|W / cr|1_1|Atributos|W", type: "O", operation: 'papind' }),
  new Mapping({variable: "Consumo Esp. Água (m³/tc)", mapping:"cr|_captacao_tc|Atributos|W", type: "O", operation: 'papind' }),
  new Mapping({variable: "Consumo Vapor Vivo (kg/tc)", mapping:"cr|_consumovapor|Atributos|W / cr|1_1|Atributos|W", type: "O", operation: 'papind' }),
  new Mapping({variable: "Consumo Escape (kg/tc)", mapping:"cr|_consumoescape|Atributos|W / cr|1_1|Atributos|W", type: "O", operation: 'papind' }),
  new Mapping({variable: "Consumo V1 Processo (kg/tc)", mapping:"cr|_Consumo_V1_processo|Atributos|W", type: "O", operation: 'papind' }),
  new Mapping({variable: "Recuperação de Fábrica(%)", mapping:"cr|REC_FABRICA|Atributos|W", type: "O", operation: 'papind'}),
]

var KPIList = [
  new KPI({variable: "Moagem (tc/dia)", mapping:"cr|_moagemdia|Atributos|W", type: "O"}, { mappingReal: "ind_real_Moagem" }),
  new KPI({variable: "Açúcar (ton/dia)", mapping:"cr|_prod_vhp_dia|Atributos|W", type: "O"}, { mappingReal: "ind_real_Acucar"}),
  new KPI({variable: "Hidratado (L/dia)", mapping:"cr|_prod_hidratado_dia|Atributos|W", type: "O"}, { mappingReal: "ind_real_Hidratado"}),
  new KPI({variable: "Anidro (L/dia)", mapping:"cr|_prod_anidro_dia|Atributos|W", type: "O"}, { mappingReal: "ind_real_Anidro"}),
  new KPI({variable: "Energia (MW.h/dia)", mapping:"cr|_prod_energia|Atributos|W", type: "O"}, { mappingReal: "ind_real_Energia"}),
]

var LossDeterminedList = [
  new Mapping({ id: 1, variable: "Eficiencia na Extradção Difusor 1", mapping:"cr|_mix|Atributos|W", type: "I", operation: 'papurd' }),
  new Mapping({ id: 2, variable: "Bag. Difusor 1", mapping:"cr|_prod_energia|Atributos|W / cr|bag_1|Atributos|W", type: "O", operation: 'papurd' }),
  new Mapping({ id: 3, variable: "Eficiencia na Extradção Difusor 2", mapping:"cr|_mix|Atributos|W", type: "I", operation: 'papurd' }),
  new Mapping({ id: 4, variable: "Bag. Difusor 2", mapping:"cr|_prod_energia|Atributos|W / cr|bag_1|Atributos|W", type: "O", operation: 'papurd' }),
]

var LossOthersList = [
  new Mapping({ id: 5, variable: "Perda Cana(%) | Lavagem Cana", mapping:"cr|_mix|Atributos|W", type: "I", operation: 'papuro' }),
  new Mapping({ id: 6, variable: "Lavagem Cana", mapping:"cr|_prod_energia|Atributos|W / cr|bag_1|Atributos|W", type: "O", operation: 'papuro' }),
]

var DeterminatedLossList = [
  new LossConfiguration({...LossList[0], id: 12 }),
  new LossConfiguration({id: -9999}, LossOthersList)
]

DeterminatedLossList[0].AddChildren([LossDeterminedList[0]], LossDeterminedList[1])
DeterminatedLossList[0].AddChildren([LossDeterminedList[2]], LossDeterminedList[3])

DeterminatedLossList[1].AddChildren([LossOthersList[0]], LossOthersList[1])

var UndeterminedLossList = [
  new LossStructure(
    [new Mapping({id: 7, variable: "Indeterminadas (%)", mapping:"cr|_mix|Atributos|W", type: "I", operation: 'papuri' })],
    new Mapping({id: 8, variable: "Indeterminadas (%)", mapping:"cr|_prod_energia|Atributos|W / cr|bag_1|Atributos|W", type: "O", operation: 'papuri' })
  )
]


export {
  KPI,
  Mapping,
  ChartList,
  LossList,
  IndicatorList,
  KPIList,
  DeterminatedLossList,
  UndeterminedLossList
}